import Abstract from '../view/abstract.js';

export default class TripListLi extends Abstract{
  getTemplate() {
    return '<li class="trip-events__item"></li>';
  }
}
